<template>
  <form id="frm_action">
    <div class="p-formgrid">
      <div class="">
        <div class="f-grid" style="margin: 0px 10px 0px 10px;">
          <div class="f-grid-col">
            <div class="mt-2">
              <span class="title-css">THÔNG TIN CHUNG</span>
            </div>
          </div>
        </div>
        <div class="f-grid" style="margin: 0px 10px 0px 10px;">
          <div class="f-grid-col">
            <div class="mt-2">
              <label class="txt-right">Công ty</label>
              <InputText disabled v-model="company.name" type="text" class="input-text-box cs-input"/>
            </div>
            <div class="mt-2">
              <label class="txt-right">Tên gọi SRA</label>
              <InputText disabled v-model="name" type="text" class="input-text-box cs-input"/>
            </div>
            <div class="mt-2">
              <label class="txt-right">Nhà thầu</label>
              <InputText disabled v-model="contractor.label" type="text" class="input-text-box cs-input"/>
            </div>
          </div>
          <div class="f-grid-col">
            <div class="mt-2">
              <label class="txt-right">Loại</label>
              <Dropdown disabled v-model="seltype" :options="type_list" optionValue="value" optionLabel="label" class="input-text-box m-0" @change="changeType" />
            </div>
            <div class="mt-2" v-if="seltype=='user'">
              <label class="txt-right">Nhân viên nhà thầu</label>
              <DropdownScrollable
              disabled
                placeholder="Chọn"
                :showClear="true"
                cusClass="m-0 cs-width"
                :limit="users1_obj.limit"
                :loading="users1_obj.loading"
                v-model="selusers1"
                :options="users1_obj.items"
                :total="users1_obj.total"
                @keyup="emitEventUsers1"
                @offset="changeOffsetUsers1"
                @scroll="emitEventUsers1"
              />
              <input class="input_tmp_validator_r" id="selusers1_add" />
            </div>
            <div class="mt-2" v-if="seltype=='user'">
              <label class="txt-right">Công việc</label>
              <InputText disabled v-model="work_position" id="work_position_add" type="text" class="input-text-box cs-input" maxLength="255" placeholder="Nhập"/>
            </div>
            <div class="mt-2" v-if="seltype=='equipment'">
              <label class="txt-right">Thiết bị</label>
              <DropdownScrollable
              disabled
                placeholder="Chọn"
                :showClear="true"
                cusClass="m-0 cs-width"
                :limit="equipment_obj.limit"
                :loading="equipment_obj.loading"
                v-model="selequipment"
                :options="equipment_obj.items"
                :total="equipment_obj.total"
                @keyup="emitEventEquipment"

              />
              <input class="input_tmp_validator_r" id="selequipment_add" />
            </div>
            <div class="mt-2" v-if="seltype=='supplies'">
              <label class="txt-right">Vật tư</label>
              <DropdownScrollable
              disabled
                placeholder="Chọn"
                :showClear="true"
                cusClass="m-0 cs-width"
                :limit="supplies_obj.limit"
                :loading="supplies_obj.loading"
                v-model="selsupplies"
                :options="supplies_obj.items"
                :total="supplies_obj.total"
                @keyup="emitEventSupplies"

              />
              <input class="input_tmp_validator_r" id="selsupplies_add" />
            </div>
          </div>
        </div>
        <div class="f-grid" style="margin: 10px 10px 0px 10px;">
          <div class="f-grid-col">
            <div class="mt-2">
              <span class="title-css">HỒ SƠ</span>
            </div>
          </div>
        </div>
        <div class="f-grid" style="margin: 0px 10px 0px 10px;">
          <div class="f-grid-col">
            <div class="mt-3">
              <table v-if="seltype=='contractor'" id="tb_level">
                <tr>
                  <th style="width:50px;text-align:left !important;">STT</th>
                  <th style="text-align:left !important;">Tên hồ sơ</th>
                  <th style="width:260px;text-align:left !important;">Hồ sơ</th>
                  <th style="width:100px;text-align:left !important;">Duyệt hồ sơ</th>
                  <th style="width:120px;text-align:left !important;">Người cập nhật</th>
                  <th style="width:120px;text-align:left !important;">Cập nhật cuối</th>
                  <th style="width:90px"></th>
                </tr>
                <tr v-for="(item, index) in list_profile" :key="index">
                  <td>{{index+1}}</td>
                  <td>{{item.name}}</td>
                  <td>
                    <div v-if="item.files.length > 0" class="profile-files">
                      <div class="profile-file-list">
                        <div
                          v-for="(file, fileIndex) in item.files"
                          :key="fileIndex"
                          class="profile-file-row"
                        >
                          <a
                            href="#"
                            class="profile-file-link"
                            @click.prevent="viewFile(file)"
                          >{{file.name}}</a>
                          <Button
                            icon="pi pi-download"
                            class="p-button-download p-button-link"
                            @click="downloadFiles([file])"
                          />
                        </div>
                      </div>
                    </div>
                  </td>
                  <td style="text-align: center;">
                    <Checkbox :disabled="true" v-model="item.status_check" :binary="true" style="margin-right: 0px;"/>
                  </td>
                  <td>{{item.updated_fullname}}</td>
                  <td>{{item.time}}</td>
                  <td style="text-align: center;" >
                    <!-- <Button
                      :disabled="item.upload_disable==true"
                      @click="ShowUpload(index)"
                      icon="pi pi-upload"
                      class="button-box p-button-add"
                    >
                    </Button> -->
                  </td>
                </tr>
              </table>
              <table v-if="seltype=='user'" id="tb_level">
                <tr>
                  <th style="width:50px;text-align:left !important;">STT</th>
                  <th style="text-align:left !important;">Tên hồ sơ</th>
                  <th style="width:260px;text-align:left !important;">Hồ sơ</th>
                  <th style="width:100px;text-align:left !important;">Duyệt hồ sơ</th>
                  <th style="width:120px;text-align:left !important;">Người cập nhật</th>
                  <th style="width:120px;text-align:left !important;">Cập nhật cuối</th>
                  <th style="width:90px"></th>
                </tr>
                <tr v-for="(item, index) in list_profile_users" :key="index">
                  <td>{{index+1}}</td>
                  <td>{{item.name}}</td>
                  <td>
                    <div v-if="item.files.length > 0" class="profile-files">
                      <div class="profile-file-list">
                        <div
                          v-for="(file, fileIndex) in item.files"
                          :key="fileIndex"
                          class="profile-file-row"
                        >
                          <a
                            href="#"
                            class="profile-file-link"
                            @click.prevent="viewFile(file)"
                          >{{file.name}}</a>
                          <Button
                            icon="pi pi-download"
                            class="p-button-download p-button-link"
                            @click="downloadFiles([file])"
                          />
                        </div>
                      </div>
                    </div>
                  </td>
                  <td style="text-align: center;">
                    <Checkbox :disabled="true" v-model="item.status_check" :binary="true" style="margin-right: 0px;"/>
                  </td>
                  <td>{{item.updated_fullname}}</td>
                  <td>{{item.time}}</td>
                  <td style="text-align: center;" >
                    <!-- <Button
                      :disabled="item.upload_disable==true"
                      @click="ShowUpload(index)"
                      icon="pi pi-upload"
                      class="button-box p-button-add"
                    >
                    </Button> -->
                  </td>
                </tr>
              </table>
              <table v-if="seltype=='equipment' || seltype=='supplies'" id="tb_level">
                <tr>
                  <th style="width:50px;text-align:left !important;">STT</th>
                  <th style="text-align:left !important;">Tên hồ sơ</th>
                  <th style="width:260px;text-align:left !important;">Hồ sơ</th>
                  <th style="width:100px;text-align:left !important;">Duyệt hồ sơ</th>
                  <th style="width:120px;text-align:left !important;">Người cập nhật</th>
                  <th style="width:120px;text-align:left !important;">Cập nhật cuối</th>
                  <th style="width:90px"></th>
                </tr>
                <tr v-for="(item, index) in list_profile_se" :key="index">
                  <td>{{index+1}}</td>
                  <td>{{item.name}}</td>
                  <td>
                    <div v-if="item.files.length > 0" class="profile-files">
                      <div class="profile-file-list">
                        <div
                          v-for="(file, fileIndex) in item.files"
                          :key="fileIndex"
                          class="profile-file-row"
                        >
                          <a
                            href="#"
                            class="profile-file-link"
                            @click.prevent="viewFile(file)"
                          >{{file.name}}</a>
                          <Button
                            icon="pi pi-download"
                            class="p-button-download p-button-link"
                            @click="downloadFiles([file])"
                          />
                        </div>
                      </div>
                    </div>
                  </td>
                  <td style="text-align: center;">
                    <Checkbox :disabled="true" v-model="item.status_check" :binary="true" style="margin-right: 0px;"/>
                  </td>
                  <td>{{item.updated_fullname}}</td>
                  <td>{{item.time}}</td>
                  <td style="text-align: center;" >
                    <!-- <Button
                      :disabled="item.upload_disable==true"
                      @click="ShowUpload(index)"
                      icon="pi pi-upload"
                      class="button-box p-button-add"
                    >
                    </Button> -->
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <div class="f-grid" style="margin: 0px 10px 0px 10px;">
          <div class="f-grid-col">
            <div class="mt-2">
              <div class="mt-2" v-if="seltype=='user' || seltype=='equipment' || seltype=='supplies'">
                <label class="txt-right">Trạng thái hồ sơ</label>
                <Dropdown disabled v-model="selstatus" :options="status_list" optionValue="value" optionLabel="label" class="input-text-box m-0"/>
              </div>
              <div class="mt-2" v-if="seltype=='user' && selstatus=='APPROVED'">
                <label class="txt-right">Ghi chú</label>
                <Textarea
                  disabled
                  v-model="remark"
                  :autoResize="true"
                  rows="2"
                  class="input-text-box"
                />
              </div>
              <div v-if="(seltype=='user' || seltype=='equipment' || seltype=='supplies') && selstatus=='REJECTED'" class="mt-2">
                <label class="txt-right">Lý do</label>
                <Textarea
                    disabled
                  id="note_add"
                  v-model="note"
                  :autoResize="true"
                  rows="2"
                  maxlength="14000"
                  class="input-text-box"
                  placeholder="Nhập"
                />
              </div>
              <div v-if="seltype=='contractor'" class="mt-2">
                <label class="txt-right">Ghi chú</label>
                <Textarea
                  id="note_add"
                  v-model="note"
                  :autoResize="true"
                  rows="2"
                  maxlength="2000"
                  class="input-text-box"
                  placeholder="Nhập tối đa 2000 ký tự"
                />
              </div>
            </div>
          </div>
          <div class="f-grid-col">
            
          </div>
        </div>
        <div v-if="historyParams()" class="f-grid" style="margin: 0px 10px 0px 10px;">
          <div class="f-grid-col">
            <div v-if="historyParams()" class="mt-2">
              <label class="txt-right">Lịch sử cập nhật hồ sơ</label>
              <a href="#" class="history-toggle" @click.prevent="show_history = !show_history">{{show_history ? 'Ẩn' : 'Xem'}}</a>
              <div v-show="show_history" class="contractor-history">
                <Timeline v-if="list_contractor_history.length > 0" :value="list_contractor_history">
                  <template #marker>
                    <span class="custom-marker shadow-2">
                      <i class="fa fa-circle-o active-cus"></i>
                    </span>
                  </template>
                  <template #content="slotProps">
                    <div class="contractor-history-item">
                      <div class="contractor-history-head">
                        <b>{{slotProps.item.user_name}}</b>
                        <span> ({{slotProps.item.role == 'contractor' ? 'Nhà thầu' : 'Công ty'}})</span>
                        <span class="contractor-history-time"> - {{formatHistoryTime(slotProps.item.created_at)}}</span>
                      </div>
                      <div class="contractor-history-body">
                        <div class="contractor-history-main" v-html="slotProps.item.content"></div>
                        <div v-if="slotProps.item.is_rejected" class="contractor-history-reason">Lý do từ chối: {{slotProps.item.reject_reason || 'Không có'}}</div>
                      </div>
                    </div>
                  </template>
                </Timeline>
                <div v-else style="color:#888;">Chưa có lịch sử cập nhật</div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="status_old=='APPROVED'" class="f-grid" style="margin: 10px 10px 0px 10px;">
          <div class="f-grid-col">
            <div class="mt-2">
              <span class="title-css">KHÓA ĐÀO TẠO</span>
            </div>
          </div>
        </div>
        <div v-if="status_old=='APPROVED'" class="f-grid" style="margin: 0px 10px 0px 10px;">
          <div class="f-grid-col">
            <div class="mt-3">
              <table id="kdt_tab">
                <tr>
                <th style="width:35px;">STT</th>
                  <th>Tên khóa đào tạo</th>
                  <th style="width:90px;">Loại khóa học</th>
                  <th>Thời gian</th>
                  <th>Địa điểm</th>
                  <th style="width:100px;">Kết quả</th> 
                  <th style="width:100px;">Hiệu lực đến</th> 
                  <th style="width:105px;">Người cập nhật</th>
                  <th style="width:120px;">Cập nhật cuối</th>
                  <!-- <th v-if="$store.getters.typeCompany!=='contractor'" style="width:90px;text-align: center !important;">
                      <Button @click="showAddLessonDialog()" icon="pi pi-plus" class="button-box p-button-add"></Button>
                  </th> -->
                </tr>
                <tr v-for="(item, index) in list_khoa_hoc" :key="index">
                  <td>{{index + 1}}</td>
                  <td v-html="item.name_html"></td>
                  <td>{{item.type_text}}</td>
                  <td>{{item.time_text}}</td>
                  <td>{{item.address}}</td>
                  <td>
                  <Dropdown class="dialog-drop" disabled v-model="item.selStatus" optionValue="value" :options="list_status_lesson" optionLabel="label" placeholder="Chọn"/>
                  </td>
                  <td>{{item.expired_date_user}}</td>
                  <td>{{item.updated_fullname}}</td>
                  <td>{{item.time}}</td>
                  <!-- <td v-if="$store.getters.typeCompany!=='contractor'" style="text-align: center !important;">
                      <Button @click="showDeletedDialog(item)" icon="pi pi-trash p-button-icon" class="button-box p-button-danger" style="margin-left: 2px;"></Button>
                  </td> -->
                </tr>
              </table>
            </div>
          </div>
        </div>

        <div v-if="show_gpvc==true" class="f-grid" style="margin: 10px 10px 0px 10px;">
          <div class="f-grid-col">
            <div class="mt-2">
              <span class="title-css">GIẤY PHÉP VÀO CỔNG</span>
            </div>
          </div>
        </div>
        <div v-if="show_gpvc==true" class="f-grid" style="margin: 10px 10px 0px 10px;">
          <div class="f-grid-col">
            <div class="mt-2" style="width: 50%;">
              <label class="txt-left">Thời gian hiệu lực</label>
              <Calendar disabled class="cs-width" v-model="ep_data_date" selectionMode="range" dateFormat="dd/mm/yy" :showIcon="true" :manualInput="false" :showButtonBar="true" placeholder="DD/MM/YYYY - DD/MM/YYYY"/>
            </div>
          </div>
        </div>
        <div v-if="show_gpvc==true" class="f-grid" style="margin: 10px 10px 0px 10px;">
          <div class="f-grid-col">
            <div class="mt-2" style="width: 50%;">
              <label class="txt-left">Nhà máy</label>
              <DropdownScrollable
              disabled
                placeholder="Chọn"
                :showClear="true"
                cusClass="m-0 cs-width"
                :limit="ep_factory_obj.limit"
                :loading="ep_factory_obj.loading"
                v-model="ep_factory"
                :options="ep_factory_obj.items"
                :total="ep_factory_obj.total"
              />
            </div>
          </div>
        </div>
        <div v-if="show_gpvc==true" class="f-grid" style="margin: 10px 10px 0px 10px;">
          <div class="f-grid-col">
            <div class="mt-2" style="width: 50%;">
              <label class="txt-left">Khu vực làm việc</label>
              <DropdownScrollable
              disabled
                placeholder="Chọn"
                :showClear="true"
                :multiple="false"
                cusClass="m-0 cs-width"
                :limit="ep_areas_obj.limit"
                :loading="ep_areas_obj.loading"
                v-model="ep_areas_sel"
                :options="ep_areas_obj.items"
                :total="ep_areas_obj.total"
              />
            </div>
            <div class="mt-2" style="width: 50%;">
              <label v-for="(item, index) in ep_areas" :key="index" class="cus-tags">
                <span class="cs-tag-1">
                  {{item.name}}
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <Toolbar class="fixed-bottom-toolbar">
        <template slot="right">
          <Button
            :label="$constants.TEXT_BUTTON.BACK"
            @click="backToList()"
            class="p-button-warning return-style-button" />
          <!-- <Button
            v-if="mode == 'edit'"
            :label="$constants.TEXT_BUTTON.EDIT"
            @click="saveData()"
            class="p-button-success main-style-button" /> -->
          <Button
            v-if="show_gpvc==true"
            label="Tải giấy vào cổng"
            @click="DownloadPDF()"
            class="p-button-success main-style-button" />
        </template>
      </Toolbar>

      <Dialog header="Tải tệp" :visible.sync="showEditDialog" :contentStyle="{overflow: 'visible','overflow-y': 'scroll'}" :modal="true">
        <div style="padding-top: 0px;min-width:400px;">
          <input class="input_tmp_validator" id="files">
          <div class="cus-text">Dung lượng tối đa: 50 MB</div>
          <div class="cus-text">Định dạng file: docx, doc, xlsx, pptx, pdf, png, jpg, jpeg.</div>
          <input class="p-inputtext p-component text-box-a" multiple style="background-color: #EEEEEE;" accept=".docx, .doc, .xlsx, .xls, .pptx, .pdf, .png, .jpg, .jpeg" name="files[]" type="file" @change="onFileSelect2"/>
          <div class="box-images text-box-a" v-if="profile_info && profile_info.files && profile_info.files.length > 0">
            <div class="d-flex align-items-center" v-for="(item, index) in profile_info.files" :key="index" >
              <div class="file-name" @click="openFile(item)" style="cursor: pointer; color: blue; text-decoration: underline;"> style="cursor: pointer; color: blue; text-decoration: underline;">{{ item.name }}</div>
              <div v-if="loading" class="loading-overlay">
                <div class="spinner"></div>
                <p>Đang tải lên...</p>
              </div>
              <Button icon="pi pi-download" class="p-button-download p-button-link" @click="onFileDownload(index)"/>
              <Button icon="pi pi-trash" class="p-button-secondary p-button-link text-danger" @click="onFileClear2(index)"/>
            </div>
          </div>
        </div>
        <template #footer>
          <Button label="Hủy" @click="showEditDialog = false" icon="pi pi-times" class="p-button-cancel-2"/>
          <Button type="button" label="Xác nhận" @click="EditData()" icon="pi pi-check" class="" />
        </template>
      </Dialog>

      <Dialog header="Duyệt hồ sơ nhân sự" :visible.sync="showApprovedDialog" :contentStyle="{overflow: 'visible','overflow-y': 'scroll'}" :modal="true">
        <div style="padding-top: 0px;width:400px;">
          <div>
            <span>Bạn xác nhận duyệt nhân viên nhà thầu {{selusers1?.fullname}} cho gói công việc này? Vui lòng chọn các khoá học mà nhân viên này phải tham gia:</span>
          </div>
          <div>
            <div v-for="(item, index) in list_coures_approved" :key="index">
              <Checkbox v-model="item.check" :binary="true" /><span style="padding-left: 5px;">{{item.label}}</span><br>
              <DropdownScrollable 
                style="padding-left: 16px;margin: 4px;"
                placeholder="Chọn" 
                :showClear="true" 
                cusClass=""
                :multiple="false"
                v-model="item.sel_time"
                :options="item.list_time"
              />
            </div>
            
          </div>
        </div>
        <template #footer>
          <Button label="Hủy" @click="showApprovedDialog = false" icon="pi pi-times" class="p-button-cancel-2"/>
          <Button type="button" label="Xác nhận" @click="SaveDataApproved()" icon="pi pi-check" class="" />
        </template>
      </Dialog>

      <Dialog header="Duyệt hồ sơ nhân sự" :visible.sync="showDialog" :contentStyle="{overflow: 'visible','overflow-y': 'scroll'}" :modal="true">
        <div style="padding-top: 0px;width:400px;">
          <div>
            <span>Bạn xác nhận duyệt nhân viên nhà thầu {{selusers1?.fullname}} cho gói công việc này? Vui lòng chọn các khoá học mà nhân viên này phải tham gia:</span>
          </div>
          <div>
            <div v-for="(item, index) in list_coures_approved_v2" :key="index">
              <Checkbox v-model="item.check" :disabled="item.check_old==true" :binary="true" /><span style="padding-left: 5px;">{{item.label}}</span><br>
              <DropdownScrollable 
                :disabled="item.check_old==true"
                style="padding-left: 16px;margin: 4px;"
                placeholder="Chọn" 
                :showClear="true" 
                cusClass=""
                :multiple="false"
                v-model="item.sel_time"
                :options="item.list_time"
              />
            </div>
            
          </div>
        </div>
        <template #footer>
          <Button label="Hủy" @click="showDialog = false" icon="pi pi-times" class="p-button-cancel-2"/>
          <Button type="button" label="Xác nhận" @click="SaveApproved()" icon="pi pi-check" class="" />
        </template>
      </Dialog>
      <Dialog style="" header="Xóa" :visible.sync="showDeleteDialog" :contentStyle="{overflow: 'visible'}" :modal="true">
        Bạn có chắc muốn xoá nhân sự khỏi lớp học này không?
        <template #footer>
          <Button label="Hủy" @click="showDeleteDialog = false" icon="pi pi-times" class="p-button-cancel-2" />
          <Button label="Xóa" @click="deleteDataLesson()" icon="pi pi-check" class="p-button-danger" />
        </template>
      </Dialog>
      <div v-if="loading_download" class="loading-overlay">
        <div class="spinner"></div>
        <p>Đang chuẩn bị tải xuống...</p>
      </div>
    </div>
  </form>
</template>

<script>
import DropdownScrollable from '@/components/DropdownScrollable_v2.vue';
import ApiRepository from "@/core/ApiRepository";
import moment from "moment-timezone";
import jq from 'jquery';
import JSZip from "jszip";
import { saveAs } from "file-saver";
export default {
  components:{
    DropdownScrollable
  },
  props: {
    mode: String,
    model: Object,
    users: Array,
  },
  data() {
    return {
      type_company : null,
      note : "",
      is_required : true,
      filters: {},
      maxFileSize: 10485760*5,//1024*1024*50 = 50MB
      maxFiles : 100,
      name: "",
      active: true,
      company: {},
      items: [],
      total: 0,
      loading: false,
      offset: 0,
      maxFilesProfile: 100,
      list_profile : [],
      profile_info : null,
      showEditDialog : false,
      index_update : -1,
      filesDeletes : [],
      detail_id : null,
      list_contractor_history : [],
      show_history : false,
      filesDeletes2 : [],
      filesDeletes2_tmp : [],
      filesDelete_root : [],
      filesDelete_root_tmp : [],
      contractor : {},
      type_list : [
        {value : 'contractor', label :'Hồ sơ nhà thầu'},
        {value : 'user', label :'Nhân sự'},
        {value : 'equipment', label :'Thiết bị'},
        {value : 'supplies', label :'Vật tư'},
      ],
      seltype : null,
      previousSelType : null,
      users1_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      selusers1 : null,
      work_position : '',
      list_profile_users : [],
      status_list : [
        {value : 'WAITTING', label :'Chờ duyệt'},
        {value : 'APPROVED', label :'Đã duyệt'},
        {value : 'REJECTED', label :'Từ chối'},
      ],
      selstatus : 'WAITTING',
      sra_users_id : null,
      internal_disabled : false,
      status_old : 'WAITTING',
      remark : '',
      showApprovedDialog : false,
      selequipment : null,
      equipment_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      list_profile_se : [],
      sra_supplies_equipment_id : null,
      selsupplies : null,
      supplies_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      list_coures_approved : [
        // {
        //   id : "1",
        //   label : "Khoá học 1",
        //   list_time: [{ id : "11", name : "10:00 - 12:00"},{id : "12", name : "13:00 - 15:00"}],
        //   check : false,
        //   sel_time : { id : "11", name : "10:00 - 12:00"},
        // },
      ],
      list_khoa_hoc : [],
      list_status_lesson : [
        {value: 'PASS', label: 'Đạt'},
        {value: 'FAILED', label: 'Chưa đạt'},
      ],
      list_tmp_course : [],
      list_coures_approved_v2 : [],
      showDialog : false,
      showDeleteDialog : false,
      lesson_users_deleted : null,
      show_gpvc : false,
      ep_data_date : [],
      ep_factory : null,
      ep_factory_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      ep_areas_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      ep_areas : [],
      is_load_data : false,
      sra_entrance_permit_id : null,
      ep_areas_sel : null,
      loading_download: false,
    };
  },
  async mounted() {
    this.type_company = this.$store.getters.typeCompany ?? null
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      this.is_required = false;
      if (this.$route.params.id !== undefined) this.detail_id = this.$route.params.id;
      console.log("this.model====",this.model)
      this.company = this.model.company;
      this.name = this.model.name;
      var contractor = this.model.contractor
      contractor.label = '['+contractor.code+'] '+contractor.name
      this.contractor = contractor
      if (!this.$commonFuction.isEmpty(this.$route.query)){
        if (!this.$commonFuction.isEmpty(this.$route.query.k)){
          let type = this.$route.query.k
          if(type == 'contractor'){
            this.seltype = 'contractor'
            this.previousSelType = 'contractor'
            this.getListDocumentFileAll()
            this.listContractorHistory()
          }else if(type == 'user'){
            this.seltype = 'user'
            this.previousSelType = 'user'
            if(this.model.sra_users){
              this.selusers1 = {
                id : this.model.sra_users.uid,
                name : this.model.sra_users.fullname,
                fullname : this.model.sra_users.fullname,
                username : this.model.sra_users.username,
              }
            }
          }else if(type == 'equipment'){
            this.seltype = 'equipment'
            this.previousSelType = 'equipment'
            this.selequipment = this.model.supplies_equipment
          }else if(type == 'supplies'){
            this.seltype = 'supplies'
            this.previousSelType = 'supplies'
            this.selsupplies = this.model.supplies_equipment
          }
        }
      }
      // this.getListDocumentFileAll()
    }
  },
  watch: {
    async "company_id"() {
      if ((this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN)) {
        this.company = {id: this.company_id};
      }
    },
    async "$store.getters.company_id"() {
      if ((this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN)) {
        this.$set(this,'company_id', (this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN) ? this.$store.getters?.company_id : null);
        this.company = {id: this.company_id};
      }
    },
    async "company"() {
      // await this.getListDocumentFileAll();
      if (this.mode == "edit" && this.loadKey == 0) {
        this.loadKey++;
      }
    },
    async "selusers1"(){
      this.list_profile_users = []
      this.list_coures_approved = []
      this.list_coures_approved_v2 = []
      this.selstatus = 'WAITTING'
      this.work_position = ''
      if (this.$commonFuction.isEmptyObject(this.selusers1)) {
        return;
      }else{
        this.getListDocumentFileAll()
      }
    },
    async "selequipment"(){
      this.list_profile_se = []
      this.selstatus = 'WAITTING'
      if (this.$commonFuction.isEmptyObject(this.selequipment)) {
        return;
      }else{
        this.getListDocumentFileAll()
      }
    },
    async "selsupplies"(){
      this.list_profile_se = []
      this.selstatus = 'WAITTING'
      if (this.$commonFuction.isEmptyObject(this.selsupplies)) {
        return;
      }else{
        this.getListDocumentFileAll()
      }
    },
    async "ep_factory"() {
      if(this.is_load_data == false){
        this.ep_areas_obj = {
          offset: 0,
          filters: {},
          limit: 20,
          items: [],
          total: 0,
          loading: false
        }
        this.ep_areas = []
      }        
      await this.getListAreas();
    },
  },
  methods: {
    backToList() {
      this.$emit("back",this.seltype);
    },
    async changeType(){
      // console.log("this.seltype",this.seltype)
      // console.log("this.previousSelType",this.previousSelType)
      if (this.seltype == this.previousSelType) {
        return; // Nếu giá trị không thay đổi, thoát khỏi phương thức
      }
      this.filesDeletes2 = []
      this.filesDelete_root = []
      this.list_profile = [];
      if(this.seltype == 'user'){
        this.list_profile = []
        this.previousSelType = 'user'
        // await this.getListUsers1();
      }if(this.seltype == 'contractor'){
        this.selusers1 = null
        this.previousSelType = 'contractor'
        await this.getListDocumentFileAll();
      }if(this.seltype == 'equipment'){
        this.selequipment = null
        this.previousSelType = 'equipment'
      }if(this.seltype == 'supplies'){
        this.selsupplies = null
        this.previousSelType = 'supplies'
      }
    },
    async validateData() {
      this.validationErrors = {};

      if(this.seltype == 'user'){
        let selusers1_add = document.getElementById("selusers1_add");
        if (this.$commonFuction.isEmptyObject(this.selusers1) ||this.$commonFuction.isEmpty(this.selusers1)) {
          selusers1_add.setCustomValidity("Nhân viên nhà thầu không được để trống!");
        } else {
          selusers1_add.setCustomValidity("");
        }
        let work_position_add = document.getElementById("work_position_add");
        if (this.$commonFuction.isEmpty(this.work_position)) {
          work_position_add.setCustomValidity("Công việc không được để trống!");
        } else {
          work_position_add.setCustomValidity("");
        }
      }else if(this.seltype == 'equipment'){
        let selequipment_add = document.getElementById("selequipment_add");
        if (this.$commonFuction.isEmptyObject(this.selequipment) ||this.$commonFuction.isEmpty(this.selequipment)) {
          selequipment_add.setCustomValidity("Thiết bị không được để trống!");
        } else {
          selequipment_add.setCustomValidity("");
        }
      }else if(this.seltype == 'supplies'){
        let selsupplies_add = document.getElementById("selsupplies_add");
        if (this.$commonFuction.isEmptyObject(this.selsupplies) ||this.$commonFuction.isEmpty(this.selsupplies)) {
          selsupplies_add.setCustomValidity("Vật tư không được để trống!");
        } else {
          selsupplies_add.setCustomValidity("");
        }
      }
      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },
    async saveData() {
      // this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return;
      }
      var course_lesson_users_approved = []
      var time = []
      if(this.seltype == 'user'){
        // console.log("this.status_old",this.status_old)
        if(this.status_old !== 'APPROVED'){
          if(this.selstatus == 'APPROVED'){
            this.$commonFuction.is_loading(false);
            //gọi lấy khóa học
            await this.getListCourseSra()
            this.showApprovedDialog = true
            return
          }
        }
        if(this.list_khoa_hoc.length > 0){
          for (let i = 0; i < this.list_khoa_hoc.length; i++) {
            let e = this.list_khoa_hoc[i];
            if(e.status !== e.selStatus){
              course_lesson_users_approved.push({
                id : e.id,
                status : e.status,
                selStatus : e.selStatus,
                course_id : e.course_id,
              })
            }
          }
        }
        if(this.show_gpvc == true){
          if(this.ep_data_date.length == 0 || !this.ep_data_date[0] || !this.ep_data_date[1]){
            this.$commonFuction.is_loading(false);
            alert('Vui lòng chọn thời gian hiệu lực.');
            return;
          }
          if(this.$commonFuction.isEmptyObject(this.ep_factory)){
            this.$commonFuction.is_loading(false);
            alert("Vui lòng chọn nhà máy")
            return
          }
          if(this.$commonFuction.isEmpty(this.ep_areas) || this.ep_areas.length == 0 || this.$commonFuction.isEmptyObject(this.ep_areas)){
            this.$commonFuction.is_loading(false);
            alert("Vui lòng chọn khu vực làm việc")
            return
          }
          time = [
            moment(this.ep_data_date[0]).format("YYYY-MM-DD"),
            moment(this.ep_data_date[1]).format("YYYY-MM-DD"),
          ]
        }
      }

      var params = {
        name: this.name,
        company: this.company,
        type : this.seltype,
        list_profile : this.list_profile,
        files_deleted : this.filesDeletes2,
        list_profile_users : this.list_profile_users,
        user : this.selusers1,
        note : this.note,
        status_profile : this.selstatus,
        work_position : this.work_position,
        files_deleted_root : this.filesDelete_root,
        sra_users_id : this.sra_users_id,
        coures_approved : [],
        equipment : this.selequipment,
        list_profile_se : this.list_profile_se,
        sra_supplies_equipment_id : this.sra_supplies_equipment_id,
        supplies : this.selsupplies,
        course_lesson_users_approved :course_lesson_users_approved,
        ep_factory : this.ep_factory,
        ep_areas : this.ep_areas,
        time : time,
        sra_entrance_permit_id : this.sra_entrance_permit_id,
      };
      // console.log("saveData", params);
      // this.$commonFuction.is_loading(false);
      this.$emit("save", params);
    },
    SaveDataApproved(){
      this.$commonFuction.is_loading(true);
      var list_coures_approved = this.list_coures_approved
      var coures_approved = []
      for (let i = 0; i < list_coures_approved.length; i++) {
        var e = list_coures_approved[i]
        if(e.check == true){
          if(this.$commonFuction.isEmptyObject(e.sel_time)){
            this.$commonFuction.is_loading(false);
            alert("Vui lòng chọn thời gian cho khoá học "+e.label)
            return
          }
          delete e.list_time
          coures_approved.push(e)
        }
      }
      var params = {
        name: this.name,
        company: this.company,
        type : this.seltype,
        list_profile : this.list_profile,
        files_deleted : this.filesDeletes2,
        list_profile_users : this.list_profile_users,
        user : this.selusers1,
        note : this.note,
        status_profile : this.selstatus,
        work_position : this.work_position,
        files_deleted_root : this.filesDelete_root,
        sra_users_id : this.sra_users_id,
        coures_approved : coures_approved,
        equipment : this.selequipment,
        list_profile_se : this.list_profile_se,
        sra_supplies_equipment_id : this.sra_supplies_equipment_id,
        supplies : this.selsupplies,
        course_lesson_users_approved : []
      };
      console.log("saveData", params);
      // this.$commonFuction.is_loading(false);
      this.$emit("save", params);
    },
    ShowUpload(index){
      this.index_update = -1;
      if(this.seltype =='contractor'){
        let profile = this.list_profile[index];
        // console.log("profile",profile)
        this.index_update = index;
        this.profile_info = {
          id : profile.id,
          created_at : profile.created_at,
          created_by : profile.created_by,
          files : profile.files ? JSON.parse(JSON.stringify(profile.files)) : [],
          name : profile.name,
          sra_id : profile.sra_id,
          status : profile.status,
          time : profile.time ?? '',
          updated_at : profile.updated_at,
          updated_by : profile.updated_by,
          date_update : profile.date_update ?? null,
          document_files_id : profile.document_files_id ?? null,
          check_disable : profile.check_disable,
          status_check : profile.status_check,
          upload_disable : profile.upload_disable,
          rel_object_id : profile.rel_object_id ?? null,
          ordinal : profile.ordinal ?? null,
          updated_fullname : profile.updated_fullname,
        }
      }else if(this.seltype=='user'){
        let profile = this.list_profile_users[index];
        // console.log("profile====",profile)
        this.index_update = index;
        this.profile_info = {
          id : profile.id,
          created_at : profile.created_at,
          created_by : profile.created_by,
          files : profile.files ? JSON.parse(JSON.stringify(profile.files)) : [],
          name : profile.name,
          sra_id : profile.sra_id,
          status : profile.status,
          time : profile.time ?? '',
          updated_at : profile.updated_at,
          updated_by : profile.updated_by,
          date_update : profile.date_update ?? null,
          document_files_id : profile.document_files_id ?? null,
          check_disable : profile.check_disable,
          status_check : profile.status_check,
          upload_disable : profile.upload_disable,
          ordinal : profile.ordinal ?? null,
          updated_fullname : profile.updated_fullname,
          rel_object_id : profile.rel_object_id,
          sra_users_files_users_id : profile.sra_users_files_users_id
        }
        console.log(this.profile_info)
      }else if(this.seltype=='equipment'){
        let profile = this.list_profile_se[index];
        // console.log("profile====",profile)
        this.index_update = index;
        this.profile_info = {
          id : profile.id,
          created_at : profile.created_at,
          created_by : profile.created_by,
          files : profile.files ? JSON.parse(JSON.stringify(profile.files)) : [],
          name : profile.name,
          sra_id : profile.sra_id,
          status : profile.status,
          time : profile.time ?? '',
          updated_at : profile.updated_at,
          updated_by : profile.updated_by,
          date_update : profile.date_update ?? null,
          document_files_id : profile.document_files_id ?? null,
          check_disable : profile.check_disable,
          status_check : profile.status_check,
          upload_disable : profile.upload_disable,
          ordinal : profile.ordinal ?? null,
          updated_fullname : profile.updated_fullname,
          rel_object_id : profile.rel_object_id,
          sra_supplies_equipment_files_id : profile.sra_supplies_equipment_files_id
        }
      }else if(this.seltype=='supplies'){
        let profile = this.list_profile_se[index];
        // console.log("profile====",profile)
        this.index_update = index;
        this.profile_info = {
          id : profile.id,
          created_at : profile.created_at,
          created_by : profile.created_by,
          files : profile.files ? JSON.parse(JSON.stringify(profile.files)) : [],
          name : profile.name,
          sra_id : profile.sra_id,
          status : profile.status,
          time : profile.time ?? '',
          updated_at : profile.updated_at,
          updated_by : profile.updated_by,
          date_update : profile.date_update ?? null,
          document_files_id : profile.document_files_id ?? null,
          check_disable : profile.check_disable,
          status_check : profile.status_check,
          upload_disable : profile.upload_disable,
          ordinal : profile.ordinal ?? null,
          updated_fullname : profile.updated_fullname,
          rel_object_id : profile.rel_object_id,
          sra_supplies_equipment_files_id : profile.sra_supplies_equipment_files_id
        }
      }
      this.filesDeletes2_tmp = []
      this.filesDelete_root_tmp = []
      this.showEditDialog = true
    },
    async onFileSelect(event) {
      let files = event.target.files || event.dataTransfer.files;
      if (files.length > 0) {
        if (files.length > this.maxFiles) {
          event.target.value = "";
          alert("Chỉ được upload tối đa "+this.maxFiles+" file");
          return;
        }
        let acceptTags = [
          "docx", "doc", "xlsx", "pptx", "pdf","xls",
          "DOCX", "DOC", "XLSX", "PPTX", "PDF","XLS",
        ];
        for (let i = 0; i < files.length; i++) {
          if (!acceptTags.includes(files[i].name.split(".").pop())) {
            event.target.value = ""
            alert(
              "Vui lòng upload file có định dạng là: docx, doc, xlsx, pptx, pdf."
            );
            return;
          }
        }
        if (files.length + this.profile_info.files.length > this.maxFiles) {
          event.target.value = "";
          alert("Số lượng tối đa là " + this.maxFiles + " files");
          return;
        } else {
          var arrTemp = [],
            arrFiles = [];
          for (let file of files) {
            console.log(file.type);
            // this.isImage(file){
              if (file.size <= this.maxFileSize) {
                file.source = file;
                file.objectURL = window.URL.createObjectURL(file);
                file.is_new = true;
                arrTemp.push(file);
              }else{
                arrFiles.push(file);
              }
            // }
          }
          console.log("arrTemp",arrTemp)
          if (arrFiles.length > 0) {
            event.target.value = "";
            alert("File của bạn đã quá dung lượng 50MB");
            return;
          } else {
            // this.files = this.files.concat.apply(this.files, arrTemp);
            this.profile_info.files = this.profile_info.files.concat.apply(this.profile_info.files, arrTemp);
          }
        }
      }
      console.log("this.profile_info",this.profile_info)
      event.target.value = "";
      return;
    },
    async onFileSelect2(event) {
      let files = event.target.files || event.dataTransfer.files;
      this.loading = true;
      console.log("files===",files)
      if (files.length > 0) {
        if (files.length > this.maxFilesProfile) {
          event.target.value = "";
          alert("Chỉ được upload tối đa "+this.maxFilesProfile+" file");
          this.loading = false;
          return;
        }
        let acceptTags = [
          "docx", "doc", "xlsx", "pptx", "pdf","xls",
          "DOCX", "DOC", "XLSX", "PPTX", "PDF","XLS",
          "png", "jpg", "jpeg", "PNG", "JPG", "JPEG",
        ];
        for (let i = 0; i < files.length; i++) {
          if (!acceptTags.includes(files[i].name.split(".").pop())) {
            event.target.value = ""
            alert(
              "Vui lòng upload file có định dạng là: docx, doc, xlsx, pptx, pdf, png, jpg, jpeg."
            );
            this.loading = false;
            return;
          }
        }
        if (files.length + this.profile_info.files.length > this.maxFilesProfile) {
          event.target.value = "";
          alert("Số lượng tối đa là " + this.maxFilesProfile + " files");
          this.loading = false;
          return;
        } else {
          var arrTemp = [],
            arrFiles = [];
          for (let file of files) {
            console.log(file.type);
            // this.isImage(file){
              if (file.size <= this.maxFileSize) {
                file.source = file;
                file.objectURL = window.URL.createObjectURL(file);
                file.is_new = true;
                arrTemp.push(file);
              }else{
                arrFiles.push(file);
              }
            // }
          }
          // console.log("arrTemp",arrTemp)
          if (arrFiles.length > 0) {
            event.target.value = "";
            alert("File của bạn đã quá dung lượng 50MB");
            this.loading = false;
            return;
          } else {
            console.log("arrTemp===",arrTemp);
            var tmp_add = []
            await this.$CoreService.uploadImages(this.$constants.FOLDER_S3.DOCUMENT_FILES, arrTemp).then((resImage)=> {
              tmp_add = resImage
            })
            this.profile_info.files = this.profile_info.files.concat.apply(this.profile_info.files, tmp_add);
          }
        }
      }
      console.log("this.profile_info",this.profile_info)
      event.target.value = "";
      this.loading = false;
      return;
    },
    async EditData(){
      // console.log("this.profile_info",this.profile_info)
      // console.log("index_update",this.index_update)
      const tmp = this.profile_info
      if(this.index_update >= 0){
        if(this.seltype=='contractor'){
          this.list_profile[this.index_update] = tmp;
        }else if(this.seltype=='user'){
          this.list_profile_users[this.index_update] = tmp;
        }else if(this.seltype=='equipment'){
          this.list_profile_se[this.index_update] = tmp;
        }else if(this.seltype=='supplies'){
          this.list_profile_se[this.index_update] = tmp;
        }
      }
      this.showEditDialog = false
      this.profile_info = null;
      // console.log("filesDeletes2_tmp===",this.filesDeletes2_tmp)
      if(this.filesDeletes2_tmp.length > 0){
        this.filesDeletes2 = this.filesDeletes2.concat(this.filesDeletes2_tmp);
      }
      if(this.filesDelete_root_tmp.length > 0){
        this.filesDelete_root = this.filesDelete_root.concat(this.filesDelete_root_tmp);
      }
    },
    async onFileDownload(index) {
      let file = this.profile_info.files[index];
      window.open(file.url);
    },
    onFileClear(index) {
      let file = this.profile_info.files[index];
      this.profile_info.files.splice(index, 1);
      if (file.file === "" && file.id) this.filesDeletes.push(file.id);
    },
    onFileClear2(index) {
      let file = this.profile_info.files[index];
      this.profile_info.files.splice(index, 1);
      if(file.file == 'DOCUMENT_FILES_USERS' || file.file == 'DOCUMENT_FILES_CONTRACTOR' || file.file == 'DOCUMENT_FILES_SUPPLIES_EQUIPMENT'){//là root
        if (file && file.is_old==true) this.filesDelete_root_tmp.push(file.id);
      }else{
        if (file && file.is_old==true) this.filesDeletes2_tmp.push(file.id);
      }
    },
    async getListDocumentFileAll() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        this.updateListProfile([])
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        var type = this.seltype ?? null;
        var object_id = null
        if (type == 'contractor') {
          object_id = this.contractor.id ?? null;
        } else if (type == 'user') {
          object_id = this.selusers1?.id ?? null
        } else if (type == 'equipment') {
          object_id = this.selequipment?.id ?? null
        }else if (type == 'supplies') {
          object_id = this.selsupplies?.id ?? null
        }
        if(!object_id){
          return
        }
        await ApiRepository.post("/_api/sra/document_files", {type : type ,sra_id : this.detail_id, object_id : object_id, company_id: this.company.id}, {headers}).then((res) => {
            var tmp_df = res.data.data.data ?? []
            var info = res.data.data.info ?? null
            // console.log("tmp_df===",tmp_df)
            // console.log("info===",info)
            if(type == 'contractor'){
              this.updateListProfile(tmp_df)
            }else if(type == 'user'){
              this.updateListProfileUser(tmp_df,info)
            }else if(type == 'equipment'){
              this.updateListProfileEquipment(tmp_df,info)
            }else if(type == 'supplies'){
              this.updateListProfileSupplies(tmp_df,info)
            }
        }).catch((err) => {
            console.log(err);
        })
      }
    },
    formatHistoryTime(t){
      return t ? moment(t).format("HH:mm DD/MM/YYYY") : ''
    },
    historyParams(){//tham số lấy lịch sử theo loại đang xem, null nếu chưa có đối tượng
      if(!this.detail_id) return null
      if(this.company?.company_type !== 'option_1') return null//chỉ hiển thị cho công ty option_1
      if(this.seltype == 'contractor'){
        return {url : '/_api/sra/list_contractor_history'}
      }else if(this.seltype == 'user'){
        return this.sra_users_id ? {url : '/_api/sra/list_users_history', object_id : this.sra_users_id} : null
      }else if(this.seltype == 'equipment' || this.seltype == 'supplies'){
        return this.sra_supplies_equipment_id ? {url : '/_api/sra/list_supplies_equipment_history', object_id : this.sra_supplies_equipment_id} : null
      }
      return null
    },
    async listContractorHistory(){
      var token = this.$store.getters.token ? this.$store.getters.token : null
      var hp = this.historyParams()
      if(token && hp){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var {data} = await ApiRepository.post(hp.url, {sra_id : this.detail_id, company_id: this.company.id, object_id : hp.object_id ?? null}, {headers});
        this.list_contractor_history = data.data ?? []
      }else{
        this.list_contractor_history = []
      }
    },
    updateListProfileUser(list=[],info=null){
      // console.log("list==",list)
      this.sra_users_id = info?.id ?? null
      this.listContractorHistory()
      this.work_position = info?.work_position ?? ''
      this.selstatus = info?.status ?? 'WAITTING'
      this.status_old = info?.status ?? 'WAITTING'
      this.note = info?.note ?? ''
      this.remark = info?.remark ?? ''
      var tmp = []
      let type_company = this.$store.getters.typeCompany ?? null
      if((type_company=='internal' || this.$store.getters.type == this.$constants.TYPE_USER.SUPPER_ADMIN) && info && info.status == 'APPROVED'){
        this.internal_disabled = true
      }else{
        this.internal_disabled = false
      }
      for (let i = 0; i < list.length; i++) {
        var status_check = false
        var check_disable = false
        var upload_disable = false
        // console.log("type_company==",type_company)
        if(list[i].status == 'APPROVED'){
          status_check = true
          check_disable = true
          upload_disable = true
        }else if(type_company == 'contractor'){
          check_disable = true
          if(list[i].status == 'APPROVED' || list[i].status == 'WAITTING'){
            upload_disable = true
          }
        }
        // console.log("upload_disable",upload_disable)
        list[i].status_check = status_check
        list[i].check_disable = check_disable
        list[i].upload_disable = upload_disable
        var time = ''
        if(list[i].date_update_2){
          time = moment(list[i].date_update_2).format("DD/MM/YYYY HH:mm:ss")
        }
        list[i].time = time
        tmp.push(list[i])
      }
      this.list_profile_users = tmp
      if(info && info.status == 'APPROVED'){
        //gọi lấy lớp học của user
        this.getListCourseUsers()
        //gọi lấy thông tin giấy phép ra vào cổng
        this.getListGpvc()
      }
    },
    updateListProfile(list=[]){
      var tmp = []
      let type_company = this.$store.getters.typeCompany ?? null
      for (let i = 0; i < list.length; i++) {
        var status_check = false
        var check_disable = false
        var upload_disable = false
        if(list[i].status == 'APPROVED'){
          status_check = true
          check_disable = true
          upload_disable = true
        }else if(type_company == 'contractor'){
          check_disable = true
          if(list[i].status == 'APPROVED' || list[i].status == 'WAITTING'){
            upload_disable = true
          }
        }
        list[i].status_check = status_check
        list[i].check_disable = check_disable
        list[i].upload_disable = upload_disable
        var time = ''
        if(list[i].date_update){
          time = moment(list[i].date_update).format("DD/MM/YYYY HH:mm:ss")
        }
        list[i].time = time
        tmp.push(list[i])
      }
      console.log("tmp===",tmp)
      this.list_profile = tmp
    },
    updateListProfileEquipment(list=[],info=null){
      this.sra_supplies_equipment_id = info?.id ?? null
      this.listContractorHistory()
      this.selstatus = info?.status ?? 'WAITTING'
      this.status_old = info?.status ?? 'WAITTING'
      this.note = info?.note ?? ''
      this.remark = info?.remark ?? ''
      var tmp = []
      let type_company = this.$store.getters.typeCompany ?? null
      if((type_company=='internal' || this.$store.getters.type == this.$constants.TYPE_USER.SUPPER_ADMIN) && info && info.status == 'APPROVED'){
        this.internal_disabled = true
      }else{
        this.internal_disabled = false
      }
      for (let i = 0; i < list.length; i++) {
        var status_check = false
        var check_disable = false
        var upload_disable = false
        if(list[i].status == 'APPROVED'){
          status_check = true
          check_disable = true
          upload_disable = true
        }else if(type_company == 'contractor'){
          check_disable = true
          if(list[i].status == 'APPROVED' || list[i].status == 'WAITTING'){
            upload_disable = true
          }
        }
        list[i].status_check = status_check
        list[i].check_disable = check_disable
        list[i].upload_disable = upload_disable
        var time = ''
        if(list[i].date_update_2){
          time = moment(list[i].date_update_2).format("DD/MM/YYYY HH:mm:ss")
        }
        list[i].time = time
        tmp.push(list[i])
      }
      // console.log("tmp===",tmp)
      this.list_profile_se = tmp
    },
    updateListProfileSupplies(list=[],info=null){
      this.sra_supplies_equipment_id = info?.id ?? null
      this.listContractorHistory()
      this.selstatus = info?.status ?? 'WAITTING'
      this.status_old = info?.status ?? 'WAITTING'
      this.note = info?.note ?? ''
      this.remark = info?.remark ?? ''
      var tmp = []
      let type_company = this.$store.getters.typeCompany ?? null
      if((type_company=='internal' || this.$store.getters.type == this.$constants.TYPE_USER.SUPPER_ADMIN) && info && info.status == 'APPROVED'){
        this.internal_disabled = true
      }else{
        this.internal_disabled = false
      }
      for (let i = 0; i < list.length; i++) {
        var status_check = false
        var check_disable = false
        var upload_disable = false
        if(list[i].status == 'APPROVED'){
          status_check = true
          check_disable = true
          upload_disable = true
        }else if(type_company == 'contractor'){
          check_disable = true
          if(list[i].status == 'APPROVED' || list[i].status == 'WAITTING'){
            upload_disable = true
          }
        }
        list[i].status_check = status_check
        list[i].check_disable = check_disable
        list[i].upload_disable = upload_disable
        var time = ''
        if(list[i].date_update_2){
          time = moment(list[i].date_update_2).format("DD/MM/YYYY HH:mm:ss")
        }
        list[i].time = time
        tmp.push(list[i])
      }
      // console.log("tmp===",tmp)
      this.list_profile_se = tmp
    },
    async downloadFiles(files) {
      if (!files || files.length === 0) return;

      this.loading_download = true; // bật spinner

      try {
        if (files.length === 1) {
          // tải trực tiếp
          const file = files[0];
          const a = document.createElement("a");
          a.href = file.url;
          a.download = file.name;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        } else {
          // nén zip
          const zip = new JSZip();
          const folder = zip.folder("downloads");

          for (const file of files) {
            const response = await fetch(file.url);
            const blob = await response.blob();
            folder.file(file.name, blob);
          }

          const content = await zip.generateAsync({ type: "blob" });
          saveAs(content, "download_files.zip");
        }
      } catch (e) {
        console.error("Lỗi tải file:", e);
      } finally {
        this.loading_download = false; // tắt spinner
      }
    },
    async viewFile(file) {
      if (!file || !file.url) return;

      const fileName = file.name || file.url.split("?")[0].split("/").pop() || "";
      const extension = fileName.toLowerCase().split(".").pop();
      const imageMimeTypes = {
        jpg: "image/jpeg",
        jpeg: "image/jpeg",
        png: "image/png",
        gif: "image/gif",
        webp: "image/webp",
        bmp: "image/bmp",
        svg: "image/svg+xml",
        tif: "image/tiff",
        tiff: "image/tiff",
      };
      const isPdf = extension === "pdf";
      const isImage = Object.prototype.hasOwnProperty.call(imageMimeTypes, extension);

      if (!isPdf && !isImage) {
        window.open(file.url, "_blank", "noopener,noreferrer");
        return;
      }

      // Mở tab trước khi fetch để không bị trình duyệt chặn popup.
      const previewWindow = window.open("", "_blank");
      if (!previewWindow) {
        alert("Vui lòng cho phép trình duyệt mở cửa sổ mới để xem file.");
        return;
      }

      previewWindow.opener = null;
      this.loading_download = true;

      try {
        const response = await fetch(file.url);
        if (!response.ok) {
          throw new Error(`Không thể tải file (${response.status})`);
        }

        const blob = await response.blob();
        const previewMimeType = isPdf ? "application/pdf" : imageMimeTypes[extension];
        const previewBlob = blob.type === previewMimeType
          ? blob
          : new Blob([blob], { type: previewMimeType });
        const blobUrl = URL.createObjectURL(previewBlob);

        previewWindow.location.href = blobUrl;
        const cleanupInterval = window.setInterval(() => {
          if (previewWindow.closed) {
            window.clearInterval(cleanupInterval);
            URL.revokeObjectURL(blobUrl);
          }
        }, 5000);
      } catch (e) {
        previewWindow.close();
        console.error("Lỗi xem file:", e);
        alert("Không thể mở file. Máy chủ lưu file có thể chưa cho phép truy cập CORS.");
      } finally {
        this.loading_download = false;
      }
    },
    emitEventUsers1(keyword) {
      // console.log(keyword);
      this.$delete(this.users1_obj.filters, 'name');
      if (keyword) {
        this.users1_obj.filters.name = keyword;
      }
      this.getListUsers1();
    },
    changeOffsetUsers1(value) {
      this.users1_obj.offset = value;
    },
    async getListUsers1() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.users1_obj.loading = true;
        await ApiRepository.post("/_api/users/contractor", {
          filters: this.users1_obj.filters, limit: this.users1_obj.limit, offset: this.users1_obj.offset, company_id: this.company.id, contractor_id : this.contractor.id,type_company:'contractor',role_company:'staff'}, {headers}).then((res) => {
            var tmp = res.data.data?.list
            for (let i = 0; i < tmp.length; i++) {
              tmp[i].name = tmp[i].fullname 
            }
            if (this.users1_obj.offset > 0 ) {
              this.users1_obj.items.push(...tmp);
            } else{
              this.users1_obj.items = tmp;
            }
            
            this.users1_obj.total = res.data.data.count;
            this.users1_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.users1_obj.loading = false;
        })
      }
    },

    emitEventEquipment(keyword) {
      // console.log(keyword);
      this.$delete(this.equipment_obj.filters, 'name');
      if (keyword) {
        this.equipment_obj.filters.name = keyword;
      }
      this.getListEquipment();
    },
    async getListEquipment() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.equipment_obj.loading = true;
        var type = 'equipment'
        var contractor_id = this.contractor.id ?? null;
        await ApiRepository.post("/_api/supplies_equipment/options", {
          filters: this.equipment_obj.filters, company_id: this.company.id,type : type,contractor_id : contractor_id}, {headers}).then((res) => {
            var tmp = res.data.data?.supplies_equipment
            if (this.equipment_obj.offset > 0 ) {
              this.equipment_obj.items.push(...tmp);
            } else{
              this.equipment_obj.items = tmp;
            }
            this.equipment_obj.total = res.data.data.count;
            this.equipment_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.equipment_obj.loading = false;
        })
      }
    },
    emitEventSupplies(keyword) {
      // console.log(keyword);
      this.$delete(this.equipment_obj.filters, 'name');
      if (keyword) {
        this.equipment_obj.filters.name = keyword;
      }
      this.getListSupplies();
    },
    async getListSupplies() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.supplies_obj.loading = true;
        var type = 'supplies'
        var contractor_id = this.contractor.id ?? null;
        await ApiRepository.post("/_api/supplies_equipment/options", {
          filters: this.supplies_obj.filters, company_id: this.company.id,type : type,contractor_id : contractor_id}, {headers}).then((res) => {
            var tmp = res.data.data?.supplies_equipment
            if (this.supplies_obj.offset > 0 ) {
              this.supplies_obj.items.push(...tmp);
            } else{
              this.supplies_obj.items = tmp;
            }
            this.supplies_obj.total = res.data.data.count;
            this.supplies_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.supplies_obj.loading = false;
        })
      }
    },
    async getListCourseSra(key=0) {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        }
        await ApiRepository.post("/_api/course/options_sra", {sra_id : this.detail_id, company_id: this.company.id}, {headers}).then((res) => {
            var tmp = res.data.data?.sra_course  ?? []
            if(key == 1){
              this.mapListCAv2(tmp)
            }else{
              this.mapListCA(tmp)
            }
        }).catch((err) => {
            console.log(err);
        })
      }
    },
    mapListCA(list){
      var tmp = []
      for (let i = 0; i < list.length; i++) {
        var e = list[i]
        var sel_time = null
        var list_time = []
        if(e.sra_course_lesson && e.sra_course_lesson.length > 0){
          for (let j = 0; j < e.sra_course_lesson.length; j++) {
            var e2 = e.sra_course_lesson[j]
            var tmp_label = ''
            if(e2.time_text){
              tmp_label = e2.time_text
            }
            if(tmp_label !== ''){
              if(e2.address){
                tmp_label += ' - '+e2.address
              }
            }
            list_time.push({
              id : e2.id,
              name : tmp_label,
            })
          }
          if(list_time.length == 1){
            sel_time = list_time[0]
          }
        }
        var label = ''
        if(e.course){
          if(e.course.type =='online'){
            label +='[Online] '
          }else if(e.course.type =='offline'){
            label +='[Offline] '
          }
          label += e.course.name
        }
        tmp.push({
          id : e.id,//id trong bảng sra_course
          label : label,
          check : false,
          sel_time : sel_time,
          list_time : list_time,
          course_id : e.course_id ?? null,
        })
      }
      this.list_coures_approved = tmp
    },
    async getListCourseUsers(){
      var uid = this.selusers1?.id ?? null
      if(this.detail_id){
        if(uid){
          var token = this.$store.getters.token ? this.$store.getters.token : null
          if(token){
            const headers = {"Authorization": "Bearer "+token}; 
            var {data} = await ApiRepository.post("/_api/course/sra_lesson", {sra_id : this.detail_id,uid : uid, company_id: this.company.id}, {headers})
            var value = data.data ?? [];
            this.showKhoaHoc(value)
          }
        }
      }
    },
    showKhoaHoc(list){
      var tmp = []
      var check_show_link = false
      if (this.$store.getters.controllers?.list_course && this.$store.getters.controllers?.list_course.includes('view')) {
        check_show_link = true
      }
      this.list_tmp_course = []
      this.list_tmp_course_lesson =[]
      for (let i = 0; i < list.length; i++) {
        var e = list[i]
        // console.log("e22222222222222",e)
        var disabled = true
        if(this.$store.getters.typeCompany !== 'contractor'){//k phải nhà thầu
          disabled = false
        }

        var name_html = `<span>`+e.course.name+`</span>`
        var link_course = '/admin/list-course/view/'+e.course_id+'?lesson_id='+e.sra_course_lesson_id+'&company_id='+this.company.id
        if(check_show_link == true){
          name_html = `<a style="text-decoration:underline" href="`+link_course+`">`+e.course.name+`</a>`
        }
        
        var type_text = ''
        if(e.course.type == 'online'){
          type_text = 'Online'
          disabled = true
        }else if(e.course.type == 'offline'){
          type_text = 'Offline'
        }
        var time = ''
        if(e.date_update){
          time = moment(e.date_update).format("DD/MM/YYYY HH:mm:ss")
        }
        var expired_date_user = ''
        if(e.expired_date_user){
          // expired_date_user = moment(e.expired_date_user).format("DD/MM/YYYY HH:mm")
          expired_date_user = moment(e.expiration_date).format("DD/MM/YYYY HH:mm")
        }
        this.list_tmp_course.push(e.course_id);
        var tmp_txt = ''
        if(e.sra_course_lesson.time_text){
          tmp_txt = e.sra_course_lesson.time_text
        }
        if(tmp_txt !== ''){
          if(e.sra_course_lesson.address){
            tmp_txt += ' - '+e.sra_course_lesson.address
          }
        }
        this.list_tmp_course_lesson[e.course_id]={
          id : e.sra_course_lesson_id,
          name : tmp_txt,
        };
        var selStatus = e.status ?? null
        let item = {
          id : e.id,
          sra_course_lesson_id : e.sra_course_lesson_id,
          name : e.name,
          type : e.course.type,
          type_text : type_text,
          name_html : name_html,
          address : e.sra_course_lesson.address ?? '',
          time_text : e.sra_course_lesson.time_text ?? '',
          time : time,
          updated_fullname : e.updated_fullname,
          disabled : disabled,
          status : e.status ?? null,
          selStatus : selStatus,
          course_id : e.course_id,
          expired_date_user : expired_date_user,
        }
        tmp.push(item)
      }
      // console.log("tmp======",tmp)
      this.list_khoa_hoc = tmp
    },
    async showAddLessonDialog(){
      await this.getListCourseSra(1)
      this.showDialog = true
    },
    mapListCAv2(list){
      var tmp = []
      for (let i = 0; i < list.length; i++) {
        var e = list[i]
        var sel_time = null
        var list_time = []
        if(e.sra_course_lesson && e.sra_course_lesson.length > 0){
          for (let j = 0; j < e.sra_course_lesson.length; j++) {
            var e2 = e.sra_course_lesson[j]
            var tmp_label = ''
            if(e2.time_text){
              tmp_label = e2.time_text
            }
            if(tmp_label !== ''){
              if(e2.address){
                tmp_label += ' - '+e2.address
              }
            }
            list_time.push({
              id : e2.id,
              name : tmp_label,
            })
          }
          if(list_time.length == 1){
            sel_time = list_time[0]
          }
        }
        var label = ''
        if(e.course){
          if(e.course.type =='online'){
            label +='[Online] '
          }else if(e.course.type =='offline'){
            label +='[Offline] '
          }
          label += e.course.name
        }
        var check = false
        if(this.list_tmp_course.includes(e.course_id)){
          console.log("this.list_tmp_course_lesson",this.list_tmp_course_lesson)
          check = true
          sel_time = this.list_tmp_course_lesson[e.course_id]
        }
        tmp.push({
          id : e.id,//id trong bảng sra_course
          label : label,
          check : check,
          check_old : check,
          sel_time : sel_time,
          list_time : list_time,
          course_id : e.course_id ?? null,
        })
      }
      // console.log("tmp============",tmp)
      this.list_coures_approved_v2 = tmp
    },
    async SaveApproved(){
      this.$commonFuction.is_loading(true);
      var tmp = []
      for (let i = 0; i < this.list_coures_approved_v2.length; i++) {
        var e = this.list_coures_approved_v2[i]
        // delete e.label
        if(e.check == true && e.check_old !== true){
          delete e.list_time
          delete e.check_old
          tmp.push(e)
        }
      }
      if(tmp.length > 0){
        var object = {
          sra_id : this.detail_id,
          users : this.selusers1 ?? null,
          list : tmp,
          company_id : this.company.id,
        }
        console.log("object===",object)
        var that = this;
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(token){
          const headers = {
              "Authorization": "Bearer "+token,
          };
          await ApiRepository.post("/_api/course/add_sra_lesson", object, {headers}).then((response) => {
              if (response.status === 200) {
                  that.loadKhoaDaoTao();
              } else {
                  that.$toast.add({ 
                      severity: 'error',
                      summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                      detail: response.data.message,
                      life: 3000
                  });
                  that.$commonFuction.is_loading(false);
              }
          }).catch((err) => {
              that.$toast.add({
                  severity: 'error',
                  summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                  detail: err,
                  life: 3000
              });
              that.$commonFuction.is_loading(false);
          })
        }else{
          this.$commonFuction.is_loading(false);
        }
      }else{
        this.showDialog = false
        this.$commonFuction.is_loading(false);
      }
    },
    loadKhoaDaoTao(){
      this.list_khoa_hoc = []
      this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Cập nhật thành công', life: 3000 })
      this.getListCourseUsers()
      this.showDialog = false
      this.$commonFuction.is_loading(false);
    },
    showDeletedDialog(item){
      this.lesson_users_deleted = item
      this.showDeleteDialog = true
    },
    async deleteDataLesson(){
      this.$commonFuction.is_loading(true);
      // console.log("lesson_users_deleted===",this.lesson_users_deleted)
      var object = {
        id : this.lesson_users_deleted.id,
        company_id : this.company.id
      }
      var that = this;
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {"Authorization": "Bearer "+token,};
        await ApiRepository.post("/_api/course/deleted_lesson_users", object, {headers}).then((response) => {
            if (response.status === 200) {
                that.showDeleteSuccess();
            } else {
                that.$toast.add({ 
                    severity: 'error',
                    summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                    detail: response.data.message,
                    life: 3000
                });
                that.$commonFuction.is_loading(false);
            }
        }).catch((err) => {
            if(err.response && err.response.data){
              that.$toast.add({
                  severity: 'error',
                  summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                  detail: err,
                  life: 3000
              });
            }else{
              that.$toast.add({
                  severity: 'error',
                  summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                  detail: err,
                  life: 3000
              });
            }
            that.$commonFuction.is_loading(false);
        })
      }else{
        this.$commonFuction.is_loading(false);
      }
    },
    showDeleteSuccess(){
      this.list_khoa_hoc = []
      this.getListCourseUsers()
      this.$commonFuction.is_loading(false);
      this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Xóa dữ liệu thành công', life: 3000 })
      this.showDeleteDialog = false
    },
    async getListGpvc(){
      var uid = this.selusers1?.id ?? null
      if(this.detail_id){
        if(uid){
          var token = this.$store.getters.token ? this.$store.getters.token : null
          if(token){
            const headers = {"Authorization": "Bearer "+token}; 
            var {data} = await ApiRepository.post("/_api/sra/entrance_permit_detail", {sra_id : this.detail_id,uid : uid, company_id: this.company.id}, {headers})
            var value = data.data ?? null;
            this.showGPRVC(value)
          }
        }
      }
    },
    async showGPRVC(data){
      this.is_load_data = true
      if(!data){
        this.show_gpvc = false
        this.sra_entrance_permit_id = null
      }else{
        // console.log("data===",data)
        this.sra_entrance_permit_id = data.id
        if(data.date_start && data.date_end){
          this.ep_data_date = [new Date(data.date_start), new Date(data.date_end)]
        }
        if(data.factory){
          this.ep_factory = data.factory
        }
        if(data.areas){
          this.ep_areas = data.areas
        }
        this.show_gpvc = true
        await this.getListFactory()
      }
      this.is_load_data = false
    },
    emitEventListFactory(keyword) {
      // console.log(keyword);
      this.$delete(this.ep_factory_obj.filters, 'name');
      if (keyword) {
        this.ep_factory_obj.filters.name = keyword;
      }
      this.getListFactory();
    },
    async getListFactory() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.ep_factory_obj.loading = true;
        await ApiRepository.post("/_api/factory/options", {filters: this.ep_factory_obj.filters, limit: this.ep_factory_obj.limit, offset: this.ep_factory_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
          if (this.ep_factory_obj.offset > 0 ) {
            this.ep_factory_obj.items.push(...res.data.data.factory);
          } else{
            this.ep_factory_obj.items = res.data.data.factory;
          }
          this.ep_factory_obj.total = res.data.data.count;
          this.ep_factory_obj.loading = false;
        }).catch((err) => {
          console.log(err);
          this.ep_factory_obj.loading = false;
        })
      }
    },
    emitEventListAreas(keyword) {
        this.$delete(this.ep_areas_obj.filters, 'name');
        if (keyword) {
            this.ep_areas_obj.filters.name = keyword;
        }
        this.getListAreas();
    },
    async getListAreas() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
          return;
      }
      var factory_id = this.ep_factory?.id ?? null;
      if(!factory_id){
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.ep_areas_obj.loading = true;
        await ApiRepository.post("/_api/area/options", {filters: this.ep_areas_obj.filters, limit: this.ep_areas_obj.limit, offset: this.ep_areas_obj.offset, company_id: this.company.id ,factory_id : factory_id}, {headers}).then((res) => {
            let data_option = [];
            res.data.data.area.map(m=>{
                data_option.push({id: m.id ,name: m.name})
            })
            // console.log("data_option",data_option)
            if (this.ep_areas_obj.offset > 0 ) {
                this.ep_areas_obj.items.push(...data_option);
            } else{
                this.ep_areas_obj.items = data_option;
            }
            this.ep_areas_obj.total = res.data.data.count;
            this.ep_areas_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.ep_areas_obj.loading = false;
        })
      }
    },
    async DownloadPDF(){
        var sra_users_id = this.sra_users_id ?? null
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(token){
            this.$commonFuction.is_loading(true);
            const headers = { "Authorization": "Bearer "+token};
            var {data} = await ApiRepository.post("/_api/sra/su_download_pdf", {sra_users_id: sra_users_id, company_id: this.company.id}, {headers});
            var value = data.data;
            console.log("value=====",value)
            if(value){
                var a = document.createElement('a');
                a.href = value.fileUrl;
                a.download = value.fileName;
                a.target = '_blank';
                // Use a.download if available, it prevents plugins from opening.
                if ('download' in a) {
                    a.download = value.fileName;
                }
                // Add a to the doc for click to work.
                (document.body || document.documentElement).appendChild(a);
                if (a.click) {
                    a.click(); // The click method is supported by most browsers.
                } else {
                    jq(a).click(); // Backup using jquery
                }
                // Delete the temporary link.
                a.parentNode.removeChild(a);
            }
            this.$commonFuction.is_loading(false);
        }
    },
    async openFile(file) {
      try {
        const response = await fetch(file.url, { mode: "cors" }); // url từ server
        if (!response.ok) throw new Error("Không tải được file");

        console.log("response", response);

        const blob = await response.blob();

        let mimeType = blob.type;
        if (mimeType === "application/octet-stream") {
          const ext = file.name.split(".").pop().toLowerCase();
          if (["jpg", "jpeg", "png"].includes(ext)) {
            mimeType = "image/jpeg";
          } else if (ext === "pdf") {
            mimeType = "application/pdf";
          }
        }
        console.log("mimeType", mimeType);

        const fixedBlob = new File([blob], file.name, { type: mimeType });
        const objectURL = URL.createObjectURL(fixedBlob);
        
        // nếu là PDF hoặc ảnh thì mở online trong tab mới
        if (mimeType.includes("pdf") || mimeType.includes("image")) {
          window.open(objectURL, "_blank"); // giờ sẽ hiển thị online
        } else {
          const link = document.createElement("a");
          link.href = objectURL;
          link.download = file.name || file.url.split("/").pop();
          link.click();
        }

      } catch (err) {
        console.error("Không mở được file:", err);
        alert("Không mở được file");
      }
    },
  },
  
};
</script>

<style lang="scss">
  .history-toggle {
    margin-left: 8px;
    cursor: pointer;
    user-select: none;
    font-weight: normal;
    text-decoration: underline;
  }
  .contractor-history {
    margin-top: 8px;
    .contractor-history-head {
      margin-bottom: 2px;
    }
    .contractor-history-time {
      color: #0087ff;
    }
    .contractor-history-body {
      display: flex;
      align-items: flex-start;
      gap: 16px;
    }
    .contractor-history-main {
      flex: 0 1 auto;
      min-width: 0;
      max-width: 50%;
    }
    .contractor-history-reason {
      flex: 1 1 0;
      min-width: 0;
      border-left: 3px solid #dc3545;
      padding-left: 10px;
      white-space: pre-line;
      overflow-wrap: anywhere;
    }
    .p-timeline-event {
      min-height: 0;
    }
    .p-timeline-event-opposite {
      display: none;
    }
    .p-timeline-event-content {
      padding-bottom: 12px;
      line-height: 1.4;
    }
    .active-cus {
      color: #1D3118;
      font-size: 18px;
    }
  }
label {
  font-weight: bold;
}
.button-clear {
  position: absolute;
  background-color: red;
  border-radius: 50%;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
  padding: 0;
  display: flex;
  cursor: pointer;
}
.item-img {
  width: 80px;
  height: 80px;
  position: relative;
  padding: 0;
}
.p-password .pi.pi-eye {
  color: #000;
  font-size: 14px;
}
.f-grid {
  display: flex;
  justify-content: space-between;
  margin-left: -1rem;
  flex-flow: row wrap;
}
.f-grid-col {
  flex: 1 0;
  /* background-color: #EEEEEE; */
  padding: 0rem 1rem 0rem 1rem;
  border-radius: 5px;
}
#customers {
  border-collapse: collapse;
  width: 100%;
}
.cs-width {
  width : 100% !important;
}
.cs-input {
  width : 100%;
  /* max-width: 400px !important; */
}
.title-css { 
  font-weight: bold;
}
#tb_level {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#tb_level td {
  border: 1px solid #ddd;
  padding: 6px;
}
#tb_level th {
  border: 1px solid #ddd;
  padding-top: 6px;
  padding-bottom: 6px;
  text-align: left;
  padding-left: 5px;
}
.p-button-cancel-2 {
  color : #333333;
  background-color : #F2F3F7;
  border: 1px solid #F2F3F7;
}
.download-file-cs {
  color : #0086C4;
  text-decoration: underline;
  cursor: pointer;
}
.profile-files {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 4px;
}
.profile-file-list {
  display: flex;
  flex: 1;
  min-width: 0;
  flex-direction: column;
  gap: 4px;
}
.profile-file-row {
  display: flex;
  align-items: center;
  min-width: 0;
  gap: 4px;
}
.profile-file-link {
  display: block;
  max-width: 100%;
  color: #0086C4;
  text-decoration: underline;
  overflow-wrap: anywhere;
  cursor: pointer;
}
.input_tmp_validator_r {
  display : block;
  width: 0px !important;
  height: 0px !important;
  background-color: #ffffff;
  border: unset;
  outline: unset;
  left: 1em;
}
#kdt_tab {
  /* font-family: Arial, Helvetica, sans-serif; */
  border-collapse: collapse;
  width: 100%;
}

#kdt_tab td {
  border: 1px solid #ddd;
  padding: 5px 5px 5px 5px;
  height: 40px;
  /* vertical-align: top; */
}
#kdt_tab th {
  border: 1px solid #ddd;
  padding: 5px 5px 5px 5px;
  height: 40px;
}
#kdt_tab th {
  padding-top: 5px;
  padding-bottom: 5px;
  text-align: left !important;
  background-color: #F4F4F4;
}
.cus-tags{
  border-radius: 10px;
  padding: 8px;
  margin-right: 8px;
  background-color:#F2F3F7;
}
.cs-tag-1 {
  padding: 10px 6px 10px 6px;
  font-weight: normal;
}
.cs-icon {
  color : #666666;
  padding-right: 4px;
  cursor: pointer;
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 5px solid #ccc;
  border-top: 5px solid #42b983;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 10px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

</style>
